import { render, staticRenderFns } from "./acrossBar.vue?vue&type=template&id=4b8076b5&scoped=true&"
import script from "./acrossBar.vue?vue&type=script&lang=js&"
export * from "./acrossBar.vue?vue&type=script&lang=js&"
import style0 from "./acrossBar.vue?vue&type=style&index=0&id=4b8076b5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8076b5",
  null
  
)

export default component.exports